function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSliderRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 6c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2H3v2h15c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2h5V6h-5zM22 22h-2c-1.1 0-2 .9-2 2H3v2h15c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2h5v-2h-5c0-1.1-.9-2-2-2zM11 13H9c-1.1 0-2 .9-2 2H3v2h4c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2h16v-2H13c0-1.1-.9-2-2-2z",
    fill: props.color
  }));
}

export default SvgIconSliderRexFilled;